import React from 'react'
import Layout from '@components/layout/Layout'
import Hero from '@components/content/Hero'
import Features from '@components/content/Features'
import CallToAction from '@components/content/CallToAction'

const HomePage: React.FC = () => {
  return (
    <Layout
      seo={{
        title: 'HammerMUD - Revitalizing Text-Based Gaming',
        description: 'Free-to-play MUD that honors classic traditions while embracing modern convenience. Join our community-driven virtual third space for text adventures.',
        type: 'website',
        url: import.meta.env.VITE_SITE_URL || 'https://hammermud.com',
        keywords: ['MUD', 'text-based gaming', 'free-to-play', 'community', 'virtual third space', 'multiplayer RPG', 'indie gaming', 'patreon supported']
      }}
    >
      <Hero />
      <Features />
      <CallToAction />
    </Layout>
  )
}

export default HomePage